module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-tiktok.eb505e47.svg";